import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ModalProps as BootstrapModalProps } from 'react-bootstrap';

type ModalProps = {
  titleText: string;
  submitButtonText: string;
  show: boolean;
  submitButtonDisabled?: boolean;
  backdrop?: BootstrapModalProps['backdrop'];
  dialogClassName?: string;
  onClose: () => void;
  onSubmit: () => void;
  children?: React.ReactNode;
};

export default function FormModal({
  show,
  titleText,
  submitButtonText,
  submitButtonDisabled,
  backdrop = 'static',
  dialogClassName,
  onClose,
  onSubmit,
  children,
}: ModalProps) {
  const { t } = useTranslation();
  return (
    <Modal
      show={show}
      onHide={onClose}
      backdrop={backdrop}
      dialogClassName={dialogClassName}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
      >
        <Modal.Header>
          <button type="button" className="icon-btn" onClick={onClose}>
            <i className="icon fas fa-times fa-lg"></i>
          </button>
          <h3 className="modal-title">{titleText}</h3>
        </Modal.Header>

        <div className="modal-spacer"></div>

        <Modal.Body>{children}</Modal.Body>

        <div className="modal-spacer"></div>

        <Modal.Footer>
          <button
            type="button"
            className="btn btn-primary alt"
            onClick={onClose}
          >
            {t('common.button.cancel')}
          </button>
          <button
            className="btn btn-primary"
            type="submit"
            disabled={submitButtonDisabled}
          >
            {submitButtonText}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
